import React from 'react';

const ButtonComponent  = React.memo((props) => {
    return <>
        <div className='btm-action-button'>
           <button type='button' className={props.class} disabled={props.buttonEnable} onClick={() => props.onAction()}>{props.label}</button>
        </div>
    </>
});
export default ButtonComponent;
